// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"a92819c9a6e45ea8b83a","524":"123c6a11779379664a53","810":"de1ee78d2e19dc07e2e0"}[chunkId] + ".css";
};